export class Lien {
    constructor(
        public id?: number,
        public idLien?: number,
        public parentId?: number,
        public childId?: number,
        public typeLienId?: number,
        public ordre?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/lien.model.ts